import { useContext } from 'react';

import Context from './druid/./druid/Context';

export default function useDictateContext() {
  return useContext(Context);
}
